export default {
  activeActivity: (state) => {
    return state.slide
  },
  isQuizSlide: (_, __, ___, rootGetters) => (slide) => {
    if (!slide) return false
    return slide.type === 'pickAnswer' || rootGetters['embedApp/isScoredSlide'](slide)
  },
}
